<template>
  <div class="loading-container" v-loading="isLoading"></div>
</template>

<script>
import { merchant } from "@/utils/helper";
import { loginHandde } from "../../api/wap/loginWebView";
import jwt from "jsonwebtoken";

export default {
  created() {
    let token = this.$router?.history?.current?.query?.token || "";
    console.log("token......", token);
    let user = jwt.decode(token);
    console.log("user......", user);
    loginHandde({
      vid: user.vga,
      phone: user.phone,
      bank_id: merchant.BIDV,
      lang: localStorage.getItem("language")
    })
      .then(res => {
        if (res.error_code === 0) {
          const data = res.data || {};
          window.location.href = `${data.callback_url}?token=${data.token}`;
        } else {
          this.$message.error(res.error_msg);
          this.$router.go(-1);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  data() {
    return {
      isLoading: true
    };
  }
};
</script>
<style scoped>
.loading-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
